import { useMediaQuery } from '@mui/material';
import { theme as kalepTheme } from '@provider-portal/design-common/kalep/theme/styles/themeMui';

/**
 * The NavBar renders as a permanent left sidebar from the kalep `md` breakpoint
 * (1140px) upwards; below it, the NavBarDrawer switches to a temporary drawer
 * (see NavBarDrawer's `variant`).
 *
 * The app-shell content wrapper lives outside the NavBar's BoltThemeProvider, so
 * it can't read the kalep breakpoint via `useTheme()`. This hook reads it from
 * the kalep theme directly, keeping the content's left margin in lockstep with
 * the sidebar — otherwise the content renders behind the menu in the band where
 * the sidebar is shown but the margin is not yet applied.
 */
export function useHasPermanentNavBar(): boolean {
  return useMediaQuery(kalepTheme.breakpoints.up('md'), { noSsr: true });
}
